// src/Navigation.js
import { useState, useEffect } from "react";

export default function Navigation({ currentView }) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    // Add shadow when scrolled
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 10);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // Close menu when clicking a link
    const handleLinkClick = () => {
        setIsMenuOpen(false);
    };

    return (
        <nav className={`main-nav ${isScrolled ? "scrolled" : ""}`}>
            <div className="nav-container">
                {/* Logo and Brand */}
                <a href="#/" className="nav-brand" onClick={handleLinkClick}>
                    <img
                        src="/stompinghippo_tablogo.png"
                        alt="Stomping Hippo"
                        className="nav-logo"
                    />
                    <span className="nav-brand-text">Stomping Hippo</span>
                </a>

                {/* Hamburger Menu Button (Mobile) */}
                <button
                    className="nav-toggle"
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                    aria-label="Toggle menu"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>

                {/* Navigation Links */}
                <div className={`nav-links ${isMenuOpen ? "open" : ""}`}>
                    <a
                        href="#/"
                        className={currentView === "home" ? "active" : ""}
                        onClick={handleLinkClick}
                    >
                        Home
                    </a>
                    <a
                        href="#/case-studies"
                        className={currentView === "case-studies" ? "active" : ""}
                        onClick={handleLinkClick}
                    >
                        Case Studies
                    </a>
                    <a
                        href="mailto:contact@stompinghippo.com"
                        className="nav-cta"
                        onClick={handleLinkClick}
                    >
                        Contact
                    </a>
                </div>
            </div>
        </nav>
    );
}